'use strict';

const Backbone = require('backbone');
const ProjectStatusModel = require('common/domain/entity/project-status');

class ProjectStatusCollection extends Backbone.Collection {
    constructor(models, options) {
        super(models, options);

        this.model = ProjectStatusModel;

        this._repository = options.repository;

        this._condition = options.condition || { inProgress: true };
        this._filter = options.filter;
        this._comparator = options.comparator;

        this._firstFetched = false;
        this._nextCursor = null;
        this._nextMore = null;

        this.listenTo(this._repository, 'add', projectStatus => {
            this._add(projectStatus);
        });
        this.listenTo(this._repository, 'update', projectStatus => {
            this._add(projectStatus, { merge: true });
        });
        this.listenTo(this._repository, 'remove', projectStatusID => {
            this.remove(projectStatusID);
        });
    }

    _add(projectStatus, options = {}) {
        if (this._filter && typeof(this._filter) === 'function') {
            if (! this._filter(projectStatus)) {
                // フィルタ条件を満たさない場合には、自分自身のコレクションから削除する
                this.remove(projectStatus);
                return;
            }
        }

        // CollectionView が参照している collection に対して 追加・ソートすると、正しい位置に追加されないので、
        // 別のCollectionを作成して、予め並び替えた後に、更新を行う。
        const collection = this.clone();
        collection.add(projectStatus, options);
        this.reset(collection.models);
    }

    comparator(projectStatus) {
        if (this.comparator && typeof(this._comparator) === 'function') {
            return this._comparator(projectStatus);
        }

        return projectStatus.getName();
    }

    fetchFirstPage(limit=20) {
        if (this._firstFetched) {
            return new Promise((resolve) => {
                resolve(this);
            });
        }

        return this._fetch(limit, null)
            .then(result => {
                this.add(result.models, { merge: true });
                this._setPagination(result.pagination);

                this._firstFetched = true;
                return this;
            });
    }

    _fetch(limit, cursor) {
        return this._repository.fetch(this._condition.inProgress, limit, cursor);
    }

    fetchMore(limit = 10) {
        if (! this._nextMore) {
            return new Promise((resolve) => {
                resolve(this);
            });
        }

        return this._fetch(limit, this._nextCursor)
            .then(result => {
                this.add(result.models, { merge: true });

                this._setPagination(result.pagination);

                return this;
            });
    }

    hasMore() {
        return this._nextMore;
    }

    _setPagination(pagination) {
        if (this._nextCursor === pagination.nextCursor && this._nextMore === pagination.nextMore) {
            return;
        }

        this._nextCursor = pagination.nextCursor;
        this._nextMore = pagination.nextMore;
        this.trigger('change:paginate');
    }
}

module.exports = ProjectStatusCollection;



// WEBPACK FOOTER //
// ./common/domain/collection/project-status.js